import { gql } from '@apollo/client'

/** Marketing-safe fields for marketplace /team pages. Do not add email, contact, or financial PII. */
export const GET_PUBLIC_TEAM = gql`
  query publicTeamMembers($orgId: ID!) {
    publicTeamMembers(orgId: $orgId) {
      _id
      profile {
        firstname
        lastname
      }
      jobTitle
      bioDescription
      userImage {
        url
        url_small
      }
    }
  }
`

export const GET_TEAM = gql`
  query teamMembers($orgId: ID) {
    teamMembers(orgId: $orgId) {
      _id
      email
      username
      address
      city
      zip
      state
      createdAt
      lastLogin
      disabled
      profile {
        firstname
        lastname
      }
      preferences
      roles {
        organization {
          _id
          name
        }
        role
      }
      phones
      phone
      profileURL
      userType
      jobTitle
      bioDescription
      restrictedMarketplaces
      userImage {
        url
        url_small
      }
      address
      address2
      city
      state
      zip
      DoB
      citizenship
      FICO
      firstTimeInvestor
      yearsInvesting
      realEstateInvestments
      estimatedNetWorth
      estimatedLiquidAssets
      creditReport
      scheduleOfRealEstate
      personalFinancialStatement
    }
  }
`

export const teamMembersQuery = (orgId) => ({
  query: GET_TEAM,
  variables: orgId ? { orgId } : {},
})
